import React from 'react';
import { DottedLine, PlainLine } from '../index';
import { DayTitle, DayText, DayPart, Hours } from '../elements';

/**
 * @type React.FunctionComponent<{ title: string; text?: string, CTA?: string, startHours?: string, endHours?: string, lineStyled?: string}>
 */

const DayTimeLarge = ({ title, text, startHours, endHours, lineStyled }) => {
  return (
    <div
      css={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        alignItems: 'left',
        justifyContent: 'flex-start',
      }}
    >
      <Hours>
        {startHours}
        <br />
        {endHours}
      </Hours>

      <DayPart>
        {lineStyled ? <DottedLine lineStyled={lineStyled} /> : <PlainLine />}
        <DayTitle>{title}</DayTitle>
        <DayText>{text}</DayText>
      </DayPart>
    </div>
  );
};

export default DayTimeLarge;
